import { create } from "zustand";

const SESSION_KEY = "nexo-session";

function decodePayload(token: string): Record<string, unknown> {
  try {
    const base64 = token.split(".")[1] ?? "";
    const json = atob(base64.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json);
  } catch {
    return {};
  }
}

function loadSession(): { tenantId: string; userId: string; username: string; roleName: string; appIds: string[]; subscriptionStatus: string; mustChangePassword: boolean } {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  return { tenantId: "", userId: "", username: "", roleName: "", appIds: [], subscriptionStatus: "", mustChangePassword: false };
}

function saveSession(data: { tenantId: string; userId: string; username: string; roleName: string; appIds: string[]; subscriptionStatus: string; mustChangePassword: boolean }) {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
  } catch {}
}

interface SessionState {
  tenantId: string;
  userId: string;
  username: string;
  roleName: string;
  appIds: string[];
  subscriptionStatus: string;
  mustChangePassword: boolean;
  setFromToken: (token: string) => void;
  clear: () => void;
}

const initial = loadSession();

export const useSessionStore = create<SessionState>(set => ({
  ...initial,
  setFromToken: (token: string) => {
    const payload = decodePayload(token);
    const tenantId = (payload.tenantId as string) ?? "";
    const userId = (payload.userId as string) ?? (payload.sub as string) ?? "";
    const username = (payload.username as string) ?? "";
    const roleName = (payload.roleName as string) ?? "";
    const appIds = Array.isArray(payload.appIds) ? (payload.appIds as string[]) : [];
    const subscriptionStatus = (payload.subscriptionStatus as string) ?? "";
    const mustChangePassword = (payload.mustChangePassword as boolean) ?? false;
    const data = { tenantId, userId, username, roleName, appIds, subscriptionStatus, mustChangePassword };
    saveSession(data);
    set(data);
  },
  clear: () => {
    try { sessionStorage.removeItem(SESSION_KEY); } catch {}
    set({ tenantId: "", userId: "", username: "", roleName: "", appIds: [], subscriptionStatus: "", mustChangePassword: false });
  },
}));
